<template>
  <dx-form
    v-if="deviceDays"
    id="form"
    label-location="left"
    :form-data="deviceDays"
    :col-count="1"
    :read-only="!!loading"
    :show-colon-after-label="false"
  >
    <dx-group-item :colCountByScreen="colCountByScreen">
      <!-- http://cronus.nicotech.ru:8888/issue/NIC165-26#focus=Comments-73-35098.0-0 -->
      <!--dx-simple-item data-field="factDate" editor-type="dxDateBox"
      :editor-options="{readOnly:true, type:'date', displayFormat: 'dd.MM.yyyy'}"
      >
        <dx-label text="Day" />
      </dx-simple-item-->
      <dx-simple-item data-field="device.createDate" editor-type="dxDateBox"
        :editor-options="{
          readOnly: true,
          type: 'date',
          displayFormat: 'dd.MM.yyyy HH:mm:ss',
          hint: deviceCreateDateHint
        }"
      >
        <dx-label :text="$t('device.detail.createDate')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.refreshDate" editor-type="dxDateBox"
        :editor-options="{
          readOnly: true,
          type: 'date',
          displayFormat: 'dd.MM.yyyy HH:mm:ss',
          hint: deviceRefreshDateHint
        }"
      >
        <dx-label :text="$t('device.detail.refreshDate')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.walkRefreshDate" editor-type="dxDateBox"
        :editor-options="{
          readOnly: true,
          type: 'date',
          displayFormat: 'dd.MM.yyyy HH:mm:ss',
          hint: deviceWalkRefreshDateHint
        }"
      >
        <dx-label :text="$t('device.detail.walkRefreshDate')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.isActive"
          editor-type="dxSwitch"
          :editor-options="{width: '50px'}"
        >
          <dx-label :text="$t('device.detail.managed')" :show-colon="false" />
      </dx-simple-item>
    </dx-group-item>

    <dx-group-item
      :caption="$t('device.detail.groups.general')"
      :colCountByScreen="colCountByScreen3"
    >
      <dx-simple-item data-field="device.model.vendor.code"
        :editor-options="{
          readOnly: true,
          hint: nvl('device.model.vendor.code')
        }">
        <dx-label :text="$t('device.detail.modelVendorCode')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.model.code" :editor-options="{
          readOnly: true,
          hint: nvl('device.model.code')
        }">
        <dx-label :text="$t('device.detail.model')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.serialNumber" :editor-options="{
          readOnly: true,
          hint: nvl('device.serialNumber')
        }">
        <dx-label :text="$t('device.detail.sn')" />
      </dx-simple-item>

      <!-- NIC165-87 Редактирование группы устройства -->
      <!--dx-simple-item data-field="device.location.name" :editor-options="{readOnly:true}">
        <dx-label :text="$t('device.detail.group')" />
      </dx-simple-item-->
      <dx-simple-item data-field="device.location.id"
        editor-type="dxLookup"
        :editor-options="{
          dataSource:locations,
          key: 'id',
          displayExpr: 'name',
          valueExpr: 'id',
          searchEnabled: true,
          searchExpr: ['name'],
          searchMode: 'contains',
          minSearchLength: 0,
          readOnly: !canEditDevice,
          hint: nvl('device.location.name'),
          showCancelButton: false,
          dropDownOptions: {hideOnOutsideClick: true, showTitle: false}
        }"
        :close-on-outside-click="true"
        :show-popup-title="false"
      >
        <dx-label :text="$t('device.detail.group')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.model.dim01.name" :editor-options="{
          readOnly: true,
          hint: nvl('device.model.dim01.name')
        }">
        <dx-label :text="$t('device.detail.type')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.model.dim02.name" :editor-options="{
          readOnly: true,
          hint: nvl('device.model.dim02.name')
        }">
        <dx-label :text="$t('device.detail.colorful')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.model.dim03.name" :editor-options="{
          readOnly: true,
          hint: nvl('device.model.dim03.name')
        }">
        <dx-label :text="$t('device.detail.paper')" />
      </dx-simple-item>

      <dx-simple-item data-field="pixFirmwareVersion" :editor-options="{
          readOnly: true,
          hint: nvl('pixFirmwareVersion')
        }">
        <dx-label :text="$t('device.detail.firmware')" />
      </dx-simple-item>

      <dx-simple-item data-field="lixDeviceStatus" :editor-options="{
          readOnly: true,
          hint: nvl('lixDeviceStatus')
        }">
        <dx-label :text="$t('device.detail.status')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.status.name" :editor-options="{
          readOnly: true,
          hint: nvl('device.status.name')
        }">
        <dx-label :text="$t('device.detail.statusName')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.comment" :col-span="2" editor-type="dxTextArea"
        :editor-options="{
          readOnly: !canEditDevice,
          hint: nvl('device.comment'),
          height: 55
        }">
        <dx-label :text="$t('device.detail.comment')" />
      </dx-simple-item>

      <dx-simple-item data-field="device.inventoryNumber" :editor-options="{
          readOnly: !canEditDevice,
          hint: nvl('device.inventoryNumber'),
        }">
        <dx-label :text="$t('device.detail.inventoryNumber')" />
      </dx-simple-item>
    </dx-group-item>

    <dx-group-item
      :caption="$t('device.detail.groups.address')"
      :colCountByScreen="colCountByScreen5"
    >
      <dx-simple-item data-field="pixHostname" :editor-options="{
          readOnly: true,
          hint: nvl('pixHostname')
        }">
        <dx-label :text="$t('device.detail.host')" />
      </dx-simple-item>

      <dx-simple-item data-field="lixLocation" :editor-options="{
          readOnly: true,
          hint: nvl('lixLocation')
        }">
        <dx-label :text="$t('device.detail.location')" />
      </dx-simple-item>

      <dx-simple-item data-field="pixIp" :editor-options="{
          readOnly: true,
          hint: nvl('pixIp')
        }">
        <dx-label :text="$t('device.detail.ip')" />
      </dx-simple-item>

      <dx-simple-item data-field="pixPort" :editor-options="{
          readOnly: true,
          hint: nvl('pixPort')
        }">
        <dx-label :text="$t('device.detail.port')" />
      </dx-simple-item>

      <dx-simple-item data-field="lixMac" :editor-options="{
          readOnly: true,
          hint: nvl('lixMac')
        }">
        <dx-label :text="$t('device.detail.mac')" />
      </dx-simple-item>
    </dx-group-item>

    <dx-group-item
      :caption="$t('device.detail.groups.printing')"
      :colCount="1"
    >
      <dx-group-item :colCount="3">
        <dx-simple-item data-field="pixPrinterStatus" :editor-options="{
            readOnly: true,
            hint: nvl('pixPrinterStatus')
          }">
          <dx-label :text="$t('device.detail.printStatus')" />
        </dx-simple-item>

        <dx-simple-item data-field="pixDeviceStatusCode" :editor-options="{
            readOnly: true,
            hint: nvl('pixDeviceStatusCode')
          }">
          <dx-label :text="$t('device.detail.statusCode')" />
        </dx-simple-item>
      </dx-group-item>

      <dx-group-item :colCount="3">
        <dx-simple-item data-field="lixPrintedPageCount" :editor-options="{
            readOnly: true,
            hint: nvl('lixPrintedPageCount')
          }">
          <dx-label :text="$t('device.detail.printed')" />
        </dx-simple-item>

        <dx-simple-item data-field="lixPrintedBwPageCount" :editor-options="{
            readOnly: true,
            hint: nvl('lixPrintedBwPageCount')
          }">
          <dx-label :text="$t('device.detail.bw')" />
        </dx-simple-item>

        <dx-simple-item data-field="lixPrintedColorPageCount" :editor-options="{
            readOnly: true,
            hint: nvl('lixPrintedColorPageCount')
          }">
          <dx-label :text="$t('device.detail.color')" />
        </dx-simple-item>

        <dx-empty-item />

        <dx-simple-item data-field="dayBwPageCount" :editor-options="{
            readOnly: true,
            hint: nvl('dayBwPageCount')
          }">
          <dx-label :text="$t('device.detail.bwDay')" />
        </dx-simple-item>

        <dx-simple-item data-field="dayColorPageCount" :editor-options="{
            readOnly: true,
            hint: nvl('dayColorPageCount')
          }">
          <dx-label :text="$t('device.detail.colorDay')" />
        </dx-simple-item>

        <dx-simple-item data-field="lixPrintedPageA3Count" :editor-options="{
            readOnly: true,
            hint: nvl('lixPrintedPageA3Count')
          }">
          <dx-label :text="$t('device.detail.a3')" />
        </dx-simple-item>

        <dx-simple-item data-field="lixPrintedPageA3BwCount" :editor-options="{
            readOnly: true,
            hint: nvl('lixPrintedPageA3BwCount')
          }">
          <dx-label :text="$t('device.detail.bwA3')" />
        </dx-simple-item>

        <dx-simple-item data-field="lixPrintedPageA3ColorCount" :editor-options="{
            readOnly: true,
            hint: nvl('lixPrintedPageA3ColorCount')
          }">
          <dx-label :text="$t('device.detail.colorA3')" />
        </dx-simple-item>

        <dx-simple-item data-field="lixPrintedPageA4Count" :editor-options="{
            readOnly: true,
            hint: nvl('lixPrintedPageA4Count')
          }">
          <dx-label :text="$t('device.detail.a4')" />
        </dx-simple-item>

        <dx-simple-item data-field="lixPrintedPageA4BwCount" :editor-options="{
            readOnly: true,
            hint: nvl('lixPrintedPageA4BwCount')
          }">
          <dx-label :text="$t('device.detail.bwA4')" />
        </dx-simple-item>

        <dx-simple-item data-field="lixPrintedPageA4ColorCount" :editor-options="{
            readOnly: true,
            hint: nvl('lixPrintedPageA4ColorCount')
          }">
          <dx-label :text="$t('device.detail.colorA4')" />
        </dx-simple-item>
      </dx-group-item>
    </dx-group-item>

    <dx-group-item
      :caption="$t('device.detail.groups.toner')"
      :colCountByScreen="colCountByScreen4"
    >
      <dx-simple-item data-field="lixBlackTonerLevelText" :editor-options="{
          readOnly: true,
          hint: nvl('lixBlackTonerLevelText')
        }">
        <dx-label :text="$t('device.detail.black')" />
      </dx-simple-item>

      <dx-simple-item data-field="lixCyanTonerLevelText" :editor-options="{
          readOnly: true,
          hint: nvl('lixCyanTonerLevelText')
        }">
        <dx-label :text="$t('device.detail.cyan')" />
      </dx-simple-item>

      <dx-simple-item data-field="lixMagentaTonerLevelText" :editor-options="{
          readOnly: true,
          hint: nvl('lixMagentaTonerLevelText')
        }">
        <dx-label :text="$t('device.detail.magenta')" />
      </dx-simple-item>

      <dx-simple-item data-field="lixYellowTonerLevelText" :editor-options="{
          readOnly: true,
          hint: nvl('lixYellowTonerLevelText')
        }">
        <dx-label :text="$t('device.detail.yellow')" />
      </dx-simple-item>
    </dx-group-item>

    <dx-group-item
      :caption="$t('device.detail.groups.scanCopy')"
      :colCountByScreen="colCountByScreen3"
    >
      <dx-simple-item data-field="pixScannerStatus" :editor-options="{
          readOnly: true,
          hint: nvl('pixScannerStatus')
        }">
        <dx-label :text="$t('device.detail.scanStatus')" />
      </dx-simple-item>

      <dx-simple-item data-field="lixScanPageCount" :editor-options="{
          readOnly: true,
          hint: nvl('lixScanPageCount')
        }">
        <dx-label :text="$t('device.detail.scans')" />
      </dx-simple-item>

      <dx-simple-item data-field="lixCopyPageCount" :editor-options="{
          readOnly: true,
          hint: nvl('lixCopyPageCount')
        }">
        <dx-label :text="$t('device.detail.copies')" />
      </dx-simple-item>
    </dx-group-item>

    <dx-group-item
      :caption="$t('device.detail.groups.features')"
      :colCountByScreen="colCountByScreen4"
    >
      <dx-simple-item data-field="newDevice30Flag" :editor-options="{
          readOnly: true,
          hint: nvl('newDevice30Flag')
        }">
        <dx-label :text="$t('device.detail.new30')" />
      </dx-simple-item>

      <dx-simple-item data-field="notAvailableFlag" :editor-options="{
          readOnly: true,
          hint: nvl('notAvailableFlag')
        }">
        <dx-label :text="$t('device.detail.notAvailable')" />
      </dx-simple-item>

      <dx-simple-item data-field="matReplacementRequiredFlag" :editor-options="{
          readOnly: true,
          hint: nvl('matReplacementRequiredFlag')
        }">
        <dx-label :text="$t('device.detail.replacement')" />
      </dx-simple-item>

      <dx-simple-item data-field="needAttentionFlag" :editor-options="{
          readOnly: true,
          hint: nvl('needAttentionFlag')
        }">
        <dx-label :text="$t('device.detail.attention')" />
      </dx-simple-item>
    </dx-group-item>

    <dx-group-item>
      <!-- eslint-disable vue/no-unused-vars -->
      <div slot-scope="_" id="device-detail-form-buttons">
        <aims2-button v-if="canEditDevice"
          icon="save"
          type="default"
          :text="$t('general.save')"
          :hint="$t('device.detail.actions.saveDevice')"
          :busy="saving"
          :disabled="saveDisabled"
          @click="onSave"
        />
        <aims2-button v-if="canEditDevice"
          icon="trash"
          type="danger"
          :text="$t('general.delete')"
          :disabled="loading || !deviceDays || !deviceDays.device.id"
          :busy="deleting"
          @click="onDelete"
        />
        <active-button v-if="isDownloadWalkFile"
          icon="download"
          type="normal"
          :text="$t('device.detail.actions.downloadWalkFile')"
          :disabled="disableDownloadWalkFileButton"
          @click="onDownloadWalkFile"
        />
        <active-button v-if="isUpdateWalkFile"
          type="normal"
          :text="$t('device.detail.actions.updateWalkFile')"
          @click="onUpdateWalkFile"
        />
      </div>
      <!-- eslint-enable -->
    </dx-group-item>
  </dx-form>
</template>

<script>
import {
  DxForm,
  DxSimpleItem,
  DxLabel,
  DxGroupItem,
  DxEmptyItem,
} from 'devextreme-vue/form';

import { notifier } from '@/shared/lib/notifier/index';

import { download, updateWalkFile, putDevice, deleteDevice, getUserLocations } from "@/services/api";
import { AclHandler } from "@/services/acl-handler";
import { DataBacked } from "@/mixins/dataBackedMixin";

import aims2Button from '@/components/active-button.vue';
import ActiveButton from '@/components/active-button.vue';
import showConfirmDialog from '@/components/confirm-dialog';

import { formatDateTime } from '@/utils/format';

const colCountByScreen3 = { xs: 1, sm: 2, md: 3, lg: 3 };
const colCountByScreen4 = { xs: 1, sm: 2, md: 4, lg: 4 };
const colCountByScreen5 = { xs: 1, sm: 2, md: 3, lg: 5 };

export default {
  name: 'DeviceDetail',
  props: ['deviceDays', 'id', 'loading'],
  mixins: [DataBacked],
  components: {
    DxForm, DxSimpleItem, DxLabel, DxGroupItem, DxEmptyItem,
    ActiveButton, aims2Button,
  },
  data() {
    return {
      isCloudMode: this.$store.getters.isCloudMode,
      saving: false,
      saveDisabled: false,
      deleting: false,
      colCountByScreen3,
      colCountByScreen4,
      colCountByScreen5,
      colCountByScreen: colCountByScreen3,
      disableDownloadWalkFileButton: false,
      locations: null,
    };
  },
  computed: {
    appUser() {
      return this.$store.getters.user;
    },
    aclUser() {
      return new AclHandler(this.appUser, this.isCloudMode);
    },
    isDefaultAdmin() {
      return this.aclUser.hasPermission({ roleCodes : ['ADMIN', 'DEVELOPER'] }) && this.aclUser.hasDefaultLocation();
    },
    canEditDevice() {
      return this.aclUser.hasGrantForOperation('BTN_EDIT_DEVICE', 'EXECUTE') || false;
    },
    isDownloadWalkFile() {
      const hasGrant = this.aclUser.hasGrantForOperation('BTN_DOWNLOAD_WALK', 'EXECUTE') || false;

      return this.isCloudMode ? hasGrant && this.isDefaultAdmin : hasGrant;
    },
    isUpdateWalkFile() {
      const hasGrant = this.aclUser.hasGrantForOperation('BTN_DOWNLOAD_WALK', 'EXECUTE') || false;

      return this.isCloudMode ? hasGrant && this.isDefaultAdmin : hasGrant;
    },
    deviceCreateDateHint() {
      try {
        return formatDateTime(this.deviceDays.device.createDate);
      } catch {
        return "";
      }
    },
    deviceRefreshDateHint() {
      try {
        return formatDateTime(this.deviceDays.device.refreshDate);
      } catch {
        return "";
      }
    },
    deviceWalkRefreshDateHint() {
      try {
        return formatDateTime(this.deviceDays.device.walkRefreshDate);
      } catch {
        return "";
      }
    },
  },
  methods: {
    formatDateTime,
    async loadData() {
      try {
        this.locations = await getUserLocations();
      } catch(err) {
        this.onDataError(err);
      }
    },
    async onSave() {
      try {
        this.saving = true;
        this.saveDisabled = true;
        if (!this.id) return;
        await putDevice(this.id, this.deviceDays.device);
        notifier.showSuccess(this.$t('general.updateSuccess'));
      } catch(err) {
        this.onDataError(err);
      } finally {
        this.saving = false;
        this.saveDisabled = false;
      }
    },
    async onDelete() {
      const response = await showConfirmDialog({
        title: this.$t('general.delete'),
        message: this.$t('device.detail.messages.deleteDevice'),
        btnType: 'default',
        okButton: this.$t('general.proceed'),
        cancelButton: this.$t('general.cancel'),
      });

      if (!response) return;

      try {
        this.deleting = true;
        await deleteDevice(this.id);
        notifier.showSuccess(this.$t('general.deleteSuccess'));
        setTimeout(() => this.$router.go(-1));
      } catch(err) {
        this.onDataError(err);
      } finally {
        this.deleting = false;
      }
    },
    async onDownloadWalkFile() {
      this.disableDownloadWalkFileButton = true;
      // http://cronus.nicotech.ru:8888/issue/NIC165-21#focus=Comments-73-35339.0-0
      // eslint-disable-next-line no-console
      // console.debug("DeviceDetail::onDownloadWalkFile");
      try {
        // Refused to get unsafe header "Content-Disposition
        await download(`/dm-device-days-v/device/${this.id}/walk/unknown_device.zip`, `${this.deviceDays.pixIp}-${this.deviceDays.device.modelCode}.zip`);
        notifier.showSuccess(this.$t('general.uploadSuccess'));
      } catch (err) {
        this.onDataError(err);
      }
      this.disableDownloadWalkFileButton = false;
    },
    async onUpdateWalkFile() {
      // http://cronus.nicotech.ru:8888/issue/NIC165-21#focus=Comments-73-35928.0-0
      try {
        // Refused to get unsafe header "Content-Disposition
        const res = await updateWalkFile(this.id);
        notifier.showSuccess(res.message);
      } catch (err) {
        this.onDataError(err);
      }
    },
    nvl(prop) {
      return prop.split(".")
        .reduce(
          (obj, prop) => ((obj !== "") && (obj !== null) && (prop in obj))? obj[prop]: "", this.deviceDays
        );
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
#device-detail-form-buttons {
  text-align: center;
  .dx-button {
    width: 200px;
    margin: 8px;
  }
}

.dx-item {
  margin-bottom: 10px;
}
.dx-invalid-message-content {
  padding: 0 10px !important;
}
</style>
